export const environment = {
    type: 'dev',
    applicationInsightsConnectionString: "InstrumentationKey=ba94ca48-bc6b-4438-9953-c3179ff908ba;IngestionEndpoint=https://norwayeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://norwayeast.livediagnostics.monitor.azure.com/;ApplicationId=d741c7a3-5cc1-4a9c-99d4-b3dc155014cb",
    apis: {
      InnmeldingApi: 'https://app-fagf-innmelding-dev.azurewebsites.net',
    },
  };
